import { Stack, TableCell, TableRowProps } from '@mui/material';
import { ACTION_BUTTONS_KEY, linearGradient } from './utils';
import { dataTableVariants } from './dataTableVariants';
import {
  DataTableBaseColumn,
  DataTableRow,
  DataTableSortableColumn,
  DataTableVariant,
  SxRowFunction,
} from './TableTypes';
import { colors, IconButton } from '@sweep-io/sweep-design';
import { ChevronRight } from '@sweep-io/sweep-design/dist/icons';

interface ActionCellProps<TRow extends DataTableRow> {
  row: TRow;
  columns: DataTableSortableColumn<TRow>[] | DataTableBaseColumn[];
  sxRowFunction?: SxRowFunction;
  tableRowProps?: TableRowProps;
  onClick?: (
    e: React.MouseEvent<HTMLTableCellElement, MouseEvent>,
    columnData: DataTableSortableColumn<TRow> | DataTableBaseColumn,
  ) => void;
  variant: DataTableVariant;
  hideChevronButton?: boolean;
  keepActionButtonsVisible?: boolean;
}

export const ActionCell = <TRow extends DataTableRow = any>({
  row,
  onClick,
  variant,
  hideChevronButton,
  keepActionButtonsVisible,
}: ActionCellProps<TRow>) => {
  const actionButtons = row[ACTION_BUTTONS_KEY];
  return (
    <TableCell
      key={`actions-${row.id}`}
      className="action-buttons"
      sx={{
        minWidth: '32px',
        position: 'sticky',
        p: dataTableVariants[variant].cellPadding,
        pr: variant === DataTableVariant.medium ? '24px' : '6px',
        pl: 1.5,
        right: 0,
        '&::before': {
          content: '""',
          position: 'absolute',
          inset: 0,
          background: linearGradient(colors.white),
          width: variant === DataTableVariant.small ? '30px' : '60px',
          right: 0,
          left: 'auto',
          visibility:
            onClick && !hideChevronButton ? 'visible' : actionButtons ? 'hidden' : 'hidden',
        },
      }}
      onClick={(e) => onClick && onClick(e, { field: ACTION_BUTTONS_KEY, headerName: '' })}
    >
      <Stack direction="row" gap={1} alignItems="center" justifyContent="flex-end">
        {actionButtons && (
          <Stack
            className="custom-action-button"
            sx={{
              '& button': { whiteSpace: 'nowrap' },
              opacity:
                keepActionButtonsVisible !== undefined ? (keepActionButtonsVisible ? 1 : 0) : 0,
              transition: 'opacity 0.15s ease-in-out',
            }}
          >
            {actionButtons}
          </Stack>
        )}
        {!!onClick && !hideChevronButton && (
          <Stack
            sx={{
              '& button': {
                border: 'none',

                '&:hover': {
                  border: 'none',
                  background: colors.grey[120],
                },
              },
              '& svg path': {
                stroke: colors.grey[800],
              },
            }}
          >
            <IconButton variant="system" size="tiny">
              <ChevronRight />
            </IconButton>
          </Stack>
        )}
      </Stack>
    </TableCell>
  );
};
